module.exports = __webpack_public_path__ + "static/website-image-cefef1d541d5820e9cd6fce1bc1ba66f.png";